export default {
    language: 'Sprache',
    organisation: 'Organisation',
    roles: 'Rollen'
}
